/* Kitchengoodies – snabbköp med temats originalvarukorg */
(function () {
  if (window.KGProductCardsLoaded) return;
  window.KGProductCardsLoaded = true;

  function openThemeCart() {
    var cartLinks = document.querySelectorAll(
      'a[href="/cart"], a[href$="/cart"]'
    );

    var visibleCartLink = Array.from(cartLinks).find(function (link) {
      return link.offsetParent !== null;
    });

    var cartLink = visibleCartLink || cartLinks[0];

    if (cartLink) {
      cartLink.click();
      return true;
    }

    return false;
  }
  window.KGOpenThemeCart = openThemeCart;
  document.addEventListener('change', function (event) {
    var option = event.target.closest('[data-kg-variant-option]');
    if (!option) return;

    var purchaseBox = option.closest('.kg-card-purchase');
    if (!purchaseBox) return;

    var button = purchaseBox.querySelector('[data-kg-add-to-cart]');
    var selectedText = purchaseBox.querySelector('.kg-selected-variant');

    if (button) {
      button.setAttribute('data-variant-id', option.value);
    }

    if (selectedText) {
      selectedText.textContent =
        option.getAttribute('data-variant-title') || '';
    }
  });

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-kg-add-to-cart]');

    if (!button || button.classList.contains('is-loading')) return;

    event.preventDefault();

    var variantId = Number(button.getAttribute('data-variant-id'));
    var purchaseBox = button.closest('.kg-card-purchase');
    var message = purchaseBox
      ? purchaseBox.querySelector('.kg-card-message')
      : null;

    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    if (message) {
      message.textContent = '';
      message.classList.remove('is-error');
    }

    try {
      var response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        }
      );

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || 'Produkten kunde inte läggas till.'
        );
      }

      if (message) {
        message.textContent = '✓ Tillagd i kundvagnen';
      }

      window.setTimeout(function () {
        if (!openThemeCart()) {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      }, 100);
    } catch (error) {
      if (message) {
        message.textContent =
          error.message || 'Något gick fel. Försök igen.';
        message.classList.add('is-error');
      }
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });
    /* Vanlig knapp för produkter med en enda variant */
  document.addEventListener('click', async function (event) {
    var button = event.target.closest(
  '#product-add-to-cart, #product-sticky-add-to-cart'
);

    if (!button || button.classList.contains('is-loading')) return;

    var variantId = 0;
    var productScripts = document.querySelectorAll(
      'script[type="application/json"]'
    );

    for (var i = 0; i < productScripts.length; i++) {
      try {
        var productData = JSON.parse(productScripts[i].textContent);

        if (
          productData &&
          Array.isArray(productData.variants) &&
          productData.variants.length === 1
        ) {
          variantId = Number(productData.variants[0].id);
          break;
        }
      } catch (error) {}
    }

    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        }
      );

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || 'Produkten kunde inte läggas till.'
        );
      }

      window.location.href =
  window.Shopify.routes.root + 'cart';
    } catch (error) {
      console.error('Fel vid tillägg:', error);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }, true);
    
  
})();
